import React from "react";
import { ReactComponent as Document } from '../assets/documents.svg';
import { ReactComponent as Online } from '../assets/online.svg';
// import { ReactComponent as Card } from '../assets/assistcard.svg';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import "../style2.css" ;
import ScrolltoTop from "../components/ScrolltoTop";
import UtmUpdate from "../components/WhatsAppUTMLinkUpdater";



const AlreadyBooked =()=> {
    return(
         <>
        <UtmUpdate/>
        <Navbar/>

        <div className="header">
         <div className="offer-alert">
             <div>
              <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
              <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
              <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
              <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
              <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
              </div>
              <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
         </div>
        </div>

              <div className="know-this-before-container" >

                <h1>KNOW THIS BEFORE BOOKING</h1>

                <div className="before-1">
                <div>
                <Document />
                <h2>Required Travel Documents</h2>
                </div>
                <p><span>Please take a few minutes to familiarize yourself with the required travel documents. The requirements described below are according to government regulations and policies, and are subject to change without notice.</span><br></br><br></br>
                • It is strongly recommended that all guests travel with a passport that is valid for at least 6 months beyond the end of the cruise.<br></br><br></br>
• It is the sole responsibility of the guest to identify and obtain all required travel documents for the entire cruise vacation, and to have them available whenever necessary. These appropriate, valid travel documents- passports, visas, family legal documents, and inoculation certificates - are required for boarding and re-entry into the United States and other countries.<br></br><br></br>
• Guests who do not possess the proper documentation may be prevented from boarding their flight or ship or from entering a country, and may be subject to fines. In addition, no refunds will be given to individuals who fail to bring proper documentation.<br></br><br></br>
Visas: It's the responsibility of the guest to identify, obtain and present necessary visas before the start of their cruise vacation. Requirements vary based on the guest's nationality and the countries being visited during the cruise. If you do not hold proper visa documents, you will be denied boarding without compensation.<br></br><br></br>
Important visa-related note: The most recent visa requirements for non-United States guests sailing on an Alaskan itinerary require a Canadian visa to get onboard the cruise.<br></br><br></br>
Please note these very useful tips before you board your cruise - Cruising Tips Essential</p>
                </div>
                
                <div className="before-2">
                <div>
                <Online/>
                <h2>Online Check In</h2>
                </div>
                <p>If you use the online check-in option, this will save your time later, as you won't have to fill out various elaborate forms during check-in<br></br><br></br>
On Royal Caribbean, once you have completed the online check-in successfully, you will get a Set Sail Pass that will expedite your check-in at the pier. Please note that online check-ins must be completed at least 3 days prior to your sail date.<br></br><br></br>
If you have your Set SallPass, look for the Set Sall Pass counter at the pier and present the following documents:<br></br><br></br> • Set sail Pass<br></br>
• Passport or identification document<br></br>
• Credit Card to be used for onboard expenses<br></br><br></br>
If you are sailing on Celebrity Cruises, please visit the official website and log in to My Celebrity and complete the online check-in process. Once completed, you will receive an Xpress Pass that you need to carry with you and this will make sure your check in at the pier is expedited.</p>
                </div>

                {/* <div className="before-3">
                <div>
                <Card/>
                <h2>Assists Card</h2>
                </div>
                <p>It is strongly recommended that you buy insurance coverage for your cruise. For Royal Caribbean Cruises, Celebrity Cruises and Azamara Club Cruises, you can get the Assist Card or Cruise Care Travel Insurance. The Assist Card provides coverage against loss or damage to luggage, loss of documents, and cancellations for specified reasons, in the event that you have to cancel your cruise. Please read more about the Assist Card here:<br></br><br></br>
                http://cruiseassist.assist-card.com/FAQS.aspx</p>
                </div> */}

              </div>
         
         
        <ScrolltoTop/>
        <Footer/>
        
        </>
    );
}


export default AlreadyBooked ;
